import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { getLspReportBppId } from '@/lib/utils'

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  useEffect(() => {
    const accountId = localStorage.getItem('accountId') || ''
    const bppId = getLspReportBppId(accountId)
    navigate({ to: bppId ? '/reports/lsp' : '/orders' })
  }, [])

  return null
}
